<template>
  <div class="bg-card">
    <div class="fixed header">
      <router-link :to="{ name: 'unitCleaner', params: { unitId } }"
        ><i class="material-icons smallSize">close</i>
      </router-link>
      <span>{{ $t('RestockNeeded') }}</span>
      <img class="sirenIcon" src="../assets/static/icons/siren-icon.svg" />
    </div>
    <div class="card">
      <ul class="card__list">
        <li
          :class="
            actionObj[products[i].product_id] === 'check'
              ? 'card__list-item bgLightGray'
              : actionObj[products[i].product_id] === 'cancel'
              ? 'card__list-item bgLightPrimary'
              : 'card__list-item'
          "
          v-for="(product, i) in products"
          :index="i"
          :key="i"
        >
          <img v-if="product.img_path" :src="`${product.img_path}`" />
          <div class="card__list-item__info">
            <h2>
              <span
                v-if="product.stock_general >= (product.stock_max - product.stock_curr)"
                style="color: var(--grey-Dark); font-size: 25px; font-weight: 600;"
              >
                {{ product.stock_max - product.stock_curr }}
              </span>
              <span
                v-else
                style="color: var(--grey-Dark); font-size: 25px; font-weight: 600;"
              >
                {{ product.stock_general }}
              </span>
              {{ product.product_name }}
            </h2>
            <div class="btn_wrapper">
              <div
                v-if="actionObj[product.product_id] === 'none'"
                class="btn btn--decline"
                @click="openRestockIssueForm(product)"
              >
                <i class="material-icons redColor">close</i>
              </div>
              <div
                v-if="actionObj[product.product_id] === 'none'"
                class="btn btn--accept"
                @click="restockProduct(product.product_id, product.stock_max, product.stock_curr, product.stock_general)"
              >
                <i class="material-icons greenColor">done</i>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <b-modal id="restock-issue-modal" hide-footer>
      <form class="form-container">
        <label class="reportRestockIssue">{{ $t('ReportRestockIssue') }}</label>
        <label class="form-control2">
          <input
            type="checkbox"
            @click="
              handleClick(`I don't find additional product for restock`, $event)
            "
            :checked="
              selectedOption === `I don't find additional product for restock`
            "
          />
          <span class="checkmark">{{ $t('reasonRestock1') }}</span>
        </label>
        <label class="form-control2">
          <input
            type="checkbox"
            @click="handleClick('No additional product available', $event)"
            :checked="selectedOption === 'No additional product available'"
          />
          <span class="checkmark">{{ $t('reasonRestock2') }}</span>
        </label>
        <label class="form-control2">
          <input
            type="checkbox"
            @click="handleClick('Other', $event)"
            :checked="selectedOption === 'Other'"
          />
          <span class="checkmark">{{ $t('reasonRestock3') }}</span>
        </label>
        <textarea
          v-if="selectedOption === 'Other'"
          v-model="reason"
          type="text"
          name="reason"
          class="RestockIssueMessage"
          :class="{ errorBg: $v.reason.$error }"
          @blur="$v.reason.$touch()"
          @focus="$v.reason.$reset()"
          maxlength="250"
        ></textarea>
        <template v-if="selectedOption === 'Other' && $v.reason.$error">
          <p v-if="!$v.reason.required" class="errorMessage">
            {{ $t('reasonReq') }}
          </p>
        </template>
        <button
          :disabled="
            reasonText == null || (selectedOption === 'Other' && $v.$invalid)
          "
          class="add-btn"
          type="submit"
          name="button"
          @click.prevent="sendRestockRejectionMailToClient()"
        >
          {{ $t('sendMail') }}
        </button>
      </form>
    </b-modal>

    <b-modal
      id="success-modal-restock"
      title=""
      hide-footer
      @close="restockSucceed"
    >
      <div>
        <h2>{{ $t('restockSuccess') }}</h2>
        <br />
        <h4>{{ $t('restockSuccess3') }}</h4>
        <br />
        <figure class="about-img2">
          <img src="../assets/static/images/illustrations/cleaner.svg" />
        </figure>
        <br />
        <SuccessTickIconAnim @perform-tick-click-action="restockSucceed" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import SuccessTickIconAnim from '@/components/common/SuccessTickIconAnim.vue'

export default {
  components: {
    SuccessTickIconAnim
  },
  data() {
    return {
      unitId: this.$route.params.unitId,
      products: [],
      reason: '',
      reasonText: null,
      otherChecked: false,
      targetProduct: {},
      actionObj: {},
      selectedOption: null,
      productTraversed: 0
    }
  },
  validations() {
    return {
      reason: { required }
    }
  },
  async created() {
    this.products = await this.$store.dispatch(
      'unitProduct/fetchUnitProductsToRestock',
      this.$route.params.unitId
    )
    this.products.forEach(product => {
      this.actionObj[product.product_id] = 'none'
    })
  },
  methods: {
    async restockProduct(productId, maxStock, currStock, generalStock) {
      const stocktoUpdate = currStock + (generalStock >= maxStock - currStock ? maxStock - currStock : generalStock)
      await this.$store.dispatch('unitProduct/editUnitProductStock', {
        unit_id: this.unitId,
        product_id: productId,
        stock_curr: stocktoUpdate
      })
      //   alert(`stock updated`)
      this.actionObj[productId] = 'check'
      this.actionObj = JSON.parse(JSON.stringify(this.actionObj))
      this.checkAllProductsTraversed()
    },
    openRestockIssueForm(product) {
      this.targetProduct = product
      this.$bvModal.show('restock-issue-modal')
    },
    async sendRestockRejectionMailToClient() {
      if (this.selectedOption === 'Other') {
        this.reasonText = this.reason
      }
      await this.$store.dispatch('client/sendRestockRejectionMailToClient', {
        unitId: this.unitId,
        productId: this.targetProduct.product_id,
        reason: this.reasonText
      })
      alert(`mail sent to client`)
      this.$bvModal.hide('restock-issue-modal')
      this.actionObj[this.targetProduct.product_id] = 'cancel'
      this.actionObj = JSON.parse(JSON.stringify(this.actionObj))
      this.checkAllProductsTraversed()
    },
    handleClick(option, event) {
      if (event.target.checked) {
        this.selectedOption = option
        this.reasonText = option
      } else {
        event.preventDefault()
      }
    },
    checkAllProductsTraversed() {
      this.productTraversed++
      if (this.productTraversed === this.products.length) {
        this.$bvModal.show('success-modal-restock')
      }
    },
    restockSucceed() {
      this.$router.push({
        name: 'unit-list-cleaner',
        params: { lang: this.$i18n.locale }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-card {
  background: #eceff1;
  display: grid;
  align-items: center;
  margin: 0;
}

.btn_wrapper {
  display: flex;
  justify-content: space-around;
  width: 50vw;
  height: 7vh;
}

.card__title {
  font-size: 2rem;
  color: var(--bright);
}

.fixed {
  position: fixed;
  &--center {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.smallSize {
  font-size: 35px !important;
}

.header {
  width: 100%;
  height: 60vh;
  z-index: 0;
  top: 0;
  left: 0;
  color: white;
  text-align: center;
  background: var(--bg);
  background: -webkit-linear-gradient(
    16deg,
    rgba(76, 158, 134, 1) 0%,
    rgba(61, 113, 109, 1) 8%,
    rgba(47, 71, 85, 1) 38%,
    rgba(44, 62, 80, 1) 47%,
    rgba(44, 62, 80, 1) 50%,
    rgba(44, 62, 80, 1) 80%
  );
  background: linear-gradient(
    16deg,
    rgba(76, 158, 134, 1) 0%,
    rgba(61, 113, 109, 1) 8%,
    rgba(47, 71, 85, 1) 38%,
    rgba(44, 62, 80, 1) 47%,
    rgba(44, 62, 80, 1) 50%,
    rgba(44, 62, 80, 1) 80%
  );
  clip-path: polygon(0 1%, 100% 0%, 100% 76%, 0 89%);
  display: flex;
  span {
    display: block;
    font-size: 2rem;
    padding-top: 4rem;
    text-shadow: 1px 1px 1px black;
    margin-left: 40%;
  }
  @media (max-width: 768px) {
    span {
      margin-left: 10%;
    }
  }
  i {
    padding-top: 24px;
    padding-left: 10px;
  }
}

.btn {
  position: relative;
  width: 45px;
  height: 45px;
  padding: 0.2rem;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 6px 6px -3px rgba(0, 0, 0, 0.02),
    0 10px 14px 1px rgba(0, 0, 0, 0.02), 0 4px 18px 3px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  &:active {
    transform: translateY(4px);
  }
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &::before {
      content: '';
    }
  }
  &--accept {
    background-color: none;
    padding: 0.5rem;
    color: green;
    box-shadow: 0 10px 13px -20px rgba(0, 0, 0, 0.2),
      0 5px 10px 1px rgba(0, 0, 0, 0.14), 0 8px 15px 1px rgba(0, 0, 0, 0.12);
  }
  &--decline {
    color: red;
    box-shadow: 0 10px 13px -20px rgba(0, 0, 0, 0.2),
      0 5px 10px 1px rgba(0, 0, 0, 0.14), 0 8px 15px 1px rgba(0, 0, 0, 0.12);
  }
}

.card {
  background: #fff;
  margin-top: 150px;
  padding: 33px 0px 30px;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  font-family: Poppins;
  align-items: center;
  &__icon {
    background: linear-gradient(to top, #4136f1, #8643ff);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
  }
  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
    color: var(--grey-Dark);
  }
  &__list {
    list-style: none;
    margin-top: 20px;
    padding-left: 0px;
    width: 100%;
    overflow: hidden;
    &-item {
      display: flex;
      align-items: center;
      &:not(:last-child) {
        // margin-bottom: 40px;
      }
      img {
        height: 80px;
        width: 80px;
        margin-left: 20px;
        border-radius: 16px;
        object-fit: cover;
      }
      &__info {
        margin-left: 20px;
        overflow: hidden;
        h2 {
          font-size: 15px;
          font-weight: 600;
          margin-top: 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          font-size: 12px;
          color: var(--primaryDark);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          &.comment {
            color: #4b41f1;
          }
          &.request {
            color: #f16641;
          }
          &::before {
            font-size: 18px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.sirenIcon {
  position: fixed;
  width: 80px;
  margin-bottom: 10px;
  left: 40%;
  margin-top: 110px;
}

.RestockIssueMessage {
  width: 100%;
  border: 1px solid #ced4da;
  height: 10em;
}

.close {
  position: absolute;
  right: 35px;
  top: 25px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}

.material-icons {
  font-size: 35px;
  font-weight: 900;
}

.bgLightGray {
  background-color: var(--grey-light);
}

.bgLightPrimary {
  background-color: var(--primaryLight);
}

/** Custom CheckBox Style*/

.reportRestockIssue {
  margin-bottom: 4rem;
  font-size: 1.4rem;
  font-weight: 600;
}

.form-control2 {
  /* font-family: system-ui, sans-serif;
  font-size: 2rem;
  font-weight: bold; */
  /* line-height: 1.1; */
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.7em;
}

.form-control2 span {
  text-align: left;
  margin-bottom: 40px;
  margin-top: -5px;
  font-size: 1.2rem;
}
.form-control2 + .form-control {
  margin-top: 1em;
}

.form-control2--disabled {
  color: var(--grey);
  cursor: not-allowed;
}

input[type='checkbox'] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--bright);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  padding: 0px !important;
  display: grid;
  place-content: center;
}

input[type='checkbox']::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--primary);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

input[type='checkbox']:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

input[type='checkbox']:disabled {
  --primary: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}

/** */
.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 200px;
  text-align: center;
  vertical-align: top;
}
@media screen and (max-width: 375px) {
  .card {
    margin-top: 200px;
  }
}
</style>
